import { IAction, isType } from '@zaibot/fsa';
import { CLEAR, FOUND, MISSING } from './actions';

export interface IState {
    missingNoteIds: number[];
}

const emptyState: IState = {
    missingNoteIds: [],
};

export const reducer = (state = emptyState, action: IAction) => {
    if (isType(action, FOUND)) {
        if (state.missingNoteIds.includes(action.payload.noteId)) {
            state = { missingNoteIds: state.missingNoteIds.filter((x) => x !== action.payload.noteId) };
        }
    }
    if (isType(action, MISSING)) {
        if (!state.missingNoteIds.includes(action.payload.noteId)) {
            state = { missingNoteIds: [ ...state.missingNoteIds, action.payload.noteId ] };
        }
    }
    if (isType(action, CLEAR)) {
        state = { missingNoteIds: [] };
    }
    return state;
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/locator/reducer.tsx